if (!customElements.get('component-footer-accordion')) {

    class FooterAccordion extends HTMLElement {
        constructor() {
            super();
            this.toggleAccordion = this.toggleAccordion.bind(this);
            this.content = this.nextElementSibling;
            this.onlyMobile = !!this.hasAttribute('only-mobile');
            this.size = 990;
        }

        static get observedAttributes() {
            return ['open'];
        }

        connectedCallback() {
            this.addEventListener('click', this.toggleAccordion, true);

            if (this.onlyMobile) {
                this.onlyMobileSet();
                window.addEventListener('resize', this.onlyMobileSet.bind(this));
            }

            if (this.hasAttribute('open')) {
                this.open = true;
            }
        }

        attributeChangedCallback(name, oldValue, newValue) {
            if (name === 'open' && this.content) {
                if (this.hasAttribute('open')) {
                    this.content.style.maxHeight = this.content.scrollHeight + 'px';
                } else {
                    this.content.style.maxHeight = null;
                }
            }
        }

        get open() {
            return this.hasAttribute('open');
        }

        set open(isOpen) {
            if (isOpen) {
                this.setAttribute('open', '');
                if (this.content) {
                    this.content.style.maxHeight = this.content.scrollHeight + 'px';
                }
            } else {
                this.removeAttribute('open');
                if (this.content) {
                    this.content.style.maxHeight = null;
                }
            }
        }

        toggleAccordion() {
            this.open = !this.open;
        }

        onlyMobileSet() {
            if (!window.matchMedia(`(max-width:${this.size}px)`).matches) {
                this.open = true;
            } else {
                if (this.hasAttribute('open')) {
                    this.open = true;
                }
            }
        }
    }

    customElements.define('component-footer-accordion', FooterAccordion);
}